import React from 'react';
import { Crafted } from '../../../assets/svg';
import { COMPANY_INFO } from '../../../common/constants';

export default function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="footer-wrapper">
          <p className="text-copyright">{COMPANY_INFO.FOOTER_TEXT}</p>
          <div className="logicwind-logo">
            <Crafted />
          </div>
        </div>
      </div>
    </footer>
  );
}
